import i18n from 'scoreboard/components/i18n'
import FormActionsEditor from 'scoreboard/forms/widgets/form-actions-editor'
import Logician from 'scoreboard/components/logic/logician'
import TransformationIf from 'scoreboard/imports/transform/transformation-if'
import _ from 'lodash'
import formHelper from 'scoreboard/components/form-helper'
import {getDialogDatasetOrDataset} from './pages-edit'

const FormTransformationIf = TransformationIf.extend({
	readFromDom: function() {
		this.hideFilterOptions()

		// sets the values property on the filter with the data from the value
		// input, see saveState in datasets-text-filter.js
		if (this.textFilter) this.textFilter.saveState()
		if (this.rollupFilter) this.rollupFilter.saveState()

		const data = _.extend({}, this.if, formHelper.readFromDom(this.el))
		data.updateType1 = 'manual'
		data.updateType2 = 'manual'
		return data
	},

	/**
	 * @override
	 */
	getSuggestionsForField: function(fieldId) {
		if (_.isNil(fieldId)) return []
		const suggestions = this.options.form?.get('suggestions')
		const formattedSuggestions =
			this.formatSuggestionValues(suggestions?.[fieldId])
		return formattedSuggestions ?? []
	},

	/**
	 * In instances where suggestion values are objects, such as with text
	 * fields using "Other Recorded Values", this method will format the
	 * suggestions to only include the value property if it exists.
	 * @param suggestions - The suggestions being formatted
	 * @returns {*|*[]} - The formatted suggestions or the passed in value if
	 * formatting is not necessary
	 */
	formatSuggestionValues: function(suggestions) {
		if (_.isNil(suggestions)) return []
		return suggestions.map(suggestion =>
			_.isObject(suggestion) ? suggestion?.value : suggestion
		)
	}
})

function formLogician({ formView, model, currentWidget, pageOrder, statements, allowedActionTypes }) {
	return new Logician({
		formView,
		statements: statements || [],
		conditionEditorCreator: condition => {
			// #59962
			// Ensure the correct dataset is used for dialogs
			const dataset = getDialogDatasetOrDataset(model)
			const filtersEditor = new FormTransformationIf({
				form: model,
				model: dataset,
				treeItemsById: model.treeItemsById,
				stronglyTyped: true,
				fields: _.cloneDeep(dataset.get('fields')),
				formView,
				transformation: { if: condition }
			})
			filtersEditor.on('change', () => formView.change())
			return filtersEditor
		},
		consequencesEditorCreator: (consequences, options={}) => {
			const ConsequencesEditor = FormActionsEditor.extend({
				test: function() {
					// it is okay for an else block to have no actions
					if (_.isEmpty(this.formActionEditors) &&
						!options.isElseStatement) {
						return missingConditionsOrActionsError()
					}
				}
			})
			const actionsEditor = new ConsequencesEditor({
				model,
				currentWidget,
				actions: consequences,
				allowedActionTypes,
				formView,
				pageOrder
			})
			actionsEditor.on('change', () => formView.change())
			return actionsEditor
		},
		allowedActionTypes
	})
}

const missingConditionsOrActionsError = () => {
	const args = _.map(['common.if', 'logic.then'], code => _.upperCase(i18n.get(code)))
	return i18n.highlight('logic.conditionalStatement.missingConditionAction', args)
}

export default formLogician
export { missingConditionsOrActionsError, FormTransformationIf }
formLogician.__filename__ = 'forms/edit/form-logician.js'
